export default function Coworker() {
  return (
    <div>
      <h2
        className="featured-section__heading featured-section__heading--common"
        style={{ textAlign: "center" }}
      >
        همکاری در پروژه جمع آوری تصاویر
      </h2>

      <p style={{ textAlign: "right" }}>
        اپلیکیشن اندروید زیر را دانلود و نصب کنید .
      </p>

      <p>
        <big>
          <a
            href="/apps/KBCamera.apk"
            title="K.B.Camera Download "
          >
            K.B.Camera Download
          </a>
        </big>
      </p>

      <p style={{ textAlign: "right", fontSize: "11pt", direction: "rtl" }}>
        <b>دستورالعمل تهیه تصاویر پروژه " مجموعه دادگان عوامل خسارت زا "</b>
      </p>

      <p
        dir="RTL"
        style={{ marginBottom: "11px", textAlign: "justify", fontSize: "11pt" }}
      >
        هدف تهیه عکس با استفاده از گوشی موبایل شما و اپلیکیشن KBCamera از برگ و
        ساقه و ریشه بوته هایی است که دچار بیماری یا آفت یا کمبود شده اند است در
        مزارعی که کشت آنها یکی از کشت های زیر است .
      </p>

      <p
        dir="RTL"
        style={{ marginBottom: "11px", textAlign: "justify", fontSize: "11pt" }}
      >
        کشت ها عبارتند از : خیار گوجه گندم چغندر یونجه سیب زمینی پنبه پیاز شبدر
        کلزا سویا کنجد لوبیا برنج باقلا
      </p>

      <p
        dir="RTL"
        style={{ marginBottom: "11px", textAlign: "justify", fontSize: "11pt" }}
      >
        هر مزرعه ای در هر کجای کشور که از این کشت ها باشد شما میتوانید عکس تهیه
        کنید محدودیتی وجود ندارد . کار بصورت دورکاری است ساعات کاری آزاد است در
        ازای مجموعه عکس تهیه شده ارسالی برای ما دستمزد پرداخت میگردد .
      </p>

      <p
        dir="RTL"
        style={{ marginBottom: "11px", textAlign: "justify", fontSize: "11pt" }}
      >
        عکس ها بایستی با اپلیکیشن KBCamera تهیه شود. تصاویر باید وضوح کافی داشته
        باشند تصاویر تار و ... قابل قبول نیست .
      </p>

      <p
        dir="RTL"
        style={{ marginBottom: "11px", textAlign: "justify", fontSize: "11pt" }}
      >
        عکس هایی که باید در هر مرحله گرفته شود توسط اپلیکیشن به شما اعلام
        میگردد.
      </p>

      {/* ... repeat the same pattern for the rest of your <p> blocks ... */}

      <p dir="rtl" style={{ marginBottom: "11px", textAlign: "right" }}>
        توضیحات بیشتر 02186084048
      </p>
    </div>
  );
}
